/**
 * 4.37 F2 "Copy a whole meal" — the selection rule shared by the app and the web.
 *
 * A meal is the selected day's COMPLETE entries with that `mealType` — not the
 * meal-section list (`getEntriesByMealType`), which hides standalone fluids such
 * as a glass of water logged at breakfast. Apple Health imports are left out:
 * they belong to Health, and a copy would be a KidneyPal-owned duplicate.
 */
export interface MealCopyCandidate {
  mealType: string;
  date: string;
  source?: string;
}

export function selectMealCopyEntries<T extends MealCopyCandidate>(
  entries: readonly T[],
  mealType: string,
): T[] {
  return entries.filter((e) => e.mealType === mealType && e.source !== 'healthkit');
}

/**
 * True when any entry comes from a day the user can't open (free history
 * window). Every copy path checks this before writing, not only the buttons.
 */
export function copySourceLocked(
  entries: readonly { date: string }[],
  isLocked: (dateKey: string) => boolean,
): boolean {
  return entries.some((e) => isLocked(e.date));
}
